import React from 'react';

import mobileImg from '../../../../../assets/images/seating-chart/mobile-view.svg';

const MobileView = () => (
  <div className="upload-csv__tab mobile">
    <img src={mobileImg} alt="mobile view" />
    <h1 className="">Head to a Computer to Get Started</h1>
    <p className="">At the moment, our CSV import tool only works on larger screens like your laptop.</p>
  </div>
);

export default MobileView;



// WEBPACK FOOTER //
// ./src/components/common/modals/AddGuestGroupModal/content/MobileView.jsx